var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card',[_c('p',[_vm._v("That’s right. Nico was worried because he saw how P’s BottomLine was influenced by drugs, this new boo, and even the setting where they had sex.")])])}
var staticRenderFns = []

export { render, staticRenderFns }